(() => {
  function init(root) {
    if (root.dataset.ready) return;
    root.dataset.ready = 'true';
    const originalCards = [...root.querySelectorAll('.me-shop__product[data-categories]')];
    // Present related sizes as one family without changing any Shopify product/variant identity.
    const families = [{
      title: 'Mangalitsa Bone-In Rib Chops',
      handles: ['pork-chops-jya6p', 'pork-chops-jya6p-4kdce', 'pork-chops-jya6p-3saz4', 'pork-chops-jya6p-4kdce-epg69'],
      hint: 'Standard, smaller, double & irregular rib chops'
    }, {
      title: 'Mangalitsa Belly Bacon',
      handles: ['bacon-cured-or-uncured', 'specialty-flavored-artisan-dry-rubbed-cured-bacons'],
      hint: 'Classic & artisan flavor options'
    }, {
      title: 'Mangalitsa Ham',
      handles: ['half-ham', 'half-ham-hnly4'],
      hint: 'Choose bone-in, boneless & package options'
    }];
    const collapsed = new Set();
    families.forEach(family => {
      const members = family.handles.map(handle => originalCards.find(card => card.dataset.handle === handle)).filter(Boolean);
      if (members.length < 2) return;
      const representative = members.find(card => card.dataset.available === 'true') || members[0];
      const availableMembers = members.filter(card => card.dataset.available === 'true');
      const pricedMembers = availableMembers.length ? availableMembers : members;
      const minimumPriceCard = [...pricedMembers].sort((a,b) => Number(a.dataset.price) - Number(b.dataset.price))[0];
      representative.dataset.familyHandles = members.map(card => card.dataset.handle).join(' ');
      representative.dataset.familySearch = members.map(card => card.dataset.search).join(' ');
      representative.dataset.familyTitles = members.map(card => card.dataset.title).join(' ');
      representative.dataset.familyPrices = members.map(card => card.dataset.price).join(' ');
      representative.dataset.title = family.title;
      representative.dataset.search = representative.dataset.familySearch;
      representative.dataset.price = Math.min(...pricedMembers.map(card => Number(card.dataset.price)));
      representative.dataset.available = String(members.some(card => card.dataset.available === 'true'));
      representative.dataset.created = Math.max(...members.map(card => Number(card.dataset.created)));
      representative.dataset.categories = [...new Set(members.flatMap(card => card.dataset.categories.split(' ')))].join(' ');
      const headingLink = representative.querySelector('.card__heading a');
      if (headingLink) headingLink.textContent = family.title;
      representative.querySelectorAll('.card__heading a').forEach(link => { link.textContent = family.title; });
      const price = representative.querySelector('.price');
      if (price) {
        const source = minimumPriceCard.querySelector('.price-item--sale') || minimumPriceCard.querySelector('.price-item--regular');
        if (source) { price.classList.remove('price--on-sale'); price.textContent = `From ${source.textContent.trim().replace(/^From\s+/i, '')}`; }
      }
      representative.querySelectorAll('.card__badge, .me-card-note, product-form, .quick-add, quick-add-bulk').forEach(control => control.remove());
      const information = [...representative.querySelectorAll('.card__information')].pop();
      const hint = document.createElement('p'); hint.className = 'me-card-note'; hint.textContent = family.hint;
      information?.append(hint);
      if (headingLink) {
        const choose = document.createElement('a'); choose.style.cssText = 'display:inline-block;margin-top:8px;font-size:13px;color:#644b23'; choose.href = headingLink.href; choose.textContent = 'Choose options →';
        information?.append(choose);
      }
      members.filter(card => card !== representative).forEach(card => { collapsed.add(card); card.hidden = true; card.style.setProperty('display', 'none', 'important'); card.dataset.familyMember = 'true'; });
    });
    const cards = originalCards.filter(card => !collapsed.has(card));
    const grid = root.querySelector('.me-shop__grid');
    const categories = [...root.querySelectorAll('[data-category]')];
    const search = root.querySelector('[data-shop-search]');
    const sort = root.querySelector('[data-shop-sort]');
    const method = root.querySelector('[data-shop-method]');
    const stock = root.querySelector('[data-shop-stock]');
    const mobileCategory = root.querySelector('[data-shop-category-mobile]');
    const jump = root.querySelector('[data-shop-jump]');
    let category = 'all';
    cards.forEach((card, index) => { card.dataset.order = index; });
    categories.forEach(link => {
      const count = cards.filter(card => link.dataset.category === 'all' || card.dataset.categories.split(' ').includes(link.dataset.category)).length;
      link.querySelector('[data-category-count]').textContent = count;
      link.hidden = count === 0;
      const option = [...mobileCategory.options].find(option => option.value === link.dataset.category);
      option.textContent += ` (${count})`;
      option.hidden = count === 0;
    });
    function readURL() {
      const params = new URLSearchParams(location.search);
      const requested = params.get('category') || 'all';
      category = categories.some(link => link.dataset.category === requested && !link.hidden) ? requested : 'all';
      search.value = params.get('q') || '';
      sort.value = params.get('sort') || 'featured';
      if (!sort.value) sort.value = 'featured';
      method.value = params.get('method') || 'all';
      if (!method.value) method.value = 'all';
      stock.checked = params.get('stock') === '1';
    }
    function update(writeURL = true) {
      const aliases = {'pulled pork':['shoulder','butt','picnic','brisket'], 'bbq':['barbecue','ribs','shoulder','brisket'], 'coppa':['coppa','collar','delmonico'], 'del monico':['delmonico','collar'], 'pork steak':['steak','collar'], 'charcuterie':['charcuterie','cella'], 'tender lion':['tenderloin']};
      const query = search.value.trim().toLocaleLowerCase().replace(/\s+/g,' ');
      const terms = query.split(/\s+/).filter(Boolean);
      const alternatives = aliases[query];
      const featured = ['bacon-cured-or-uncured','collar-delmonico-steaks-boneless','pork-chops-jya6p','charcuterie-sampler'];
      const rank = card => { const index = featured.indexOf(card.dataset.handle); return index >= 0 ? index : card.dataset.categories.split(' ').includes('bundles') ? 1000 : 100; };
      const ordered = [...cards].sort((a, b) => {
        if (sort.value === 'title') return a.dataset.title.localeCompare(b.dataset.title);
        if (sort.value === 'price-up') return Number(a.dataset.price) - Number(b.dataset.price);
        if (sort.value === 'price-down') return Number(b.dataset.price) - Number(a.dataset.price);
        if (sort.value === 'newest') return Number(b.dataset.created) - Number(a.dataset.created);
        return rank(a) - rank(b) || Number(a.dataset.order) - Number(b.dataset.order);
      });
      grid.querySelectorAll('[data-category-heading]').forEach(heading => heading.remove());
      const grouped = category === 'all' && sort.value === 'featured';
      const groups = categories.filter(link => link.dataset.category !== 'all');
      const primary = card => { const cats = card.dataset.categories.split(' '); return cats.includes('bundles') ? groups.findIndex(link => link.dataset.category === 'bundles') : groups.findIndex(link => cats.includes(link.dataset.category)); };
      if (grouped) ordered.sort((a,b) => primary(a) - primary(b));
      let previousGroup = -2;
      let count = 0;
      ordered.forEach(card => {
        const cats = card.dataset.categories.split(' ');
        const visible = (category === 'all' || cats.includes(category)) &&
          (method.value === 'all' || cats.includes(method.value)) &&
          (!stock.checked || card.dataset.available === 'true') &&
          (alternatives ? alternatives.some(term => (card.dataset.familyTitles || card.dataset.title).toLocaleLowerCase().includes(term)) : terms.every(term => card.dataset.search.toLocaleLowerCase().includes(term)));
        card.hidden = !visible;
        if (visible) {
          count++;
          if (grouped && primary(card) !== previousGroup) {
            previousGroup = primary(card);
            const heading = document.createElement('li');
            heading.dataset.categoryHeading = 'true';
            heading.className = 'me-shop__group-heading';
            const title = document.createElement('h3');
            title.tabIndex = -1;
            title.textContent = groups[previousGroup]?.childNodes[0].textContent.trim() || 'More Cuts';
            heading.id = `me-shop-group-${groups[previousGroup]?.dataset.category || 'other'}`;
            heading.append(title); grid.append(heading);
          }
        }
        grid.append(card);
      });
      categories.forEach(link => {
        if (link.dataset.category === category) link.setAttribute('aria-current', 'true');
        else link.removeAttribute('aria-current');
      });
      mobileCategory.value = category;
      const active = categories.find(link => link.dataset.category === category);
      root.querySelector('[data-shop-heading]').textContent = category === 'all' ? (root.dataset.collectionTitle || 'All Pork') : active.childNodes[0].textContent.trim();
      root.querySelector('[data-shop-count]').textContent = `${count} ${count === 1 ? 'selection' : 'selections'}`;
      root.querySelector('[data-shop-empty]').hidden = count > 0;
      if (jump) {
        jump.replaceChildren(new Option('Choose a section', ''));
        grid.querySelectorAll('[data-category-heading]').forEach(heading => {
          jump.add(new Option(heading.textContent.trim(), `#${heading.id}`));
        });
        jump.disabled = jump.options.length < 2;
      }
      if (writeURL) {
        const url = new URL(location.href);
        for (const [key, value] of Object.entries({category: category === 'all' ? '' : category, q: search.value.trim(), sort: sort.value === 'featured' ? '' : sort.value, method: method.value === 'all' ? '' : method.value, stock: stock.checked ? '1' : ''})) {
          if (value) url.searchParams.set(key, value); else url.searchParams.delete(key);
        }
        history.replaceState(null, '', url);
      }
    }
    function showResults() { const heading = root.querySelector('[data-shop-heading]'); heading.focus({preventScroll:true}); heading.scrollIntoView({behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',block:'start'}); }
    categories.forEach(link => link.addEventListener('click', event => {
      event.preventDefault(); category = link.dataset.category; update(); showResults();
    }));
    mobileCategory.addEventListener('change', () => { category = mobileCategory.value; update(); showResults(); });
    jump?.addEventListener('change', () => {
      if (!jump.value) return;
      const target = root.querySelector(jump.value);
      target?.scrollIntoView({behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block:'start'});
      target?.querySelector('h3')?.focus({preventScroll:true});
    });
    search.addEventListener('input', () => update());
    [sort, method, stock].forEach(control => control.addEventListener('change', () => update()));
    root.querySelectorAll('[data-shop-clear]').forEach(button => button.addEventListener('click', () => {
      category = 'all'; search.value = ''; sort.value = 'featured'; method.value = 'all'; stock.checked = false; update();
    }));
    window.addEventListener('popstate', () => { readURL(); update(false); });
    readURL(); update(false);
    if (new URLSearchParams(location.search).has('category')) requestAnimationFrame(showResults);
  }
  document.querySelectorAll('[data-me-shop]').forEach(init);
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-me-shop]').forEach(init));
})();
